import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import Btn from "../../shared/button/Btn"
import InputText from "../../shared/input/new/InputText"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { createInspectionThirdRoadRoute } from "../../../features/admin3/admin3Slice"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: auto;
        overflow-x: hidden;
        position: relative;
        .content{
            margin-block: 20px;
            padding: 0 30px;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            .input-containers{
                display: flex;
                flex-direction: column;
                gap: 20px;
                padding-bottom: 20px;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            padding-top: 20px;
            gap: 10px;
            border-top: 2px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            position: sticky;
            bottom: 0;
            z-index: 99;
            background-color: ${({ theme }) => theme.mainBgColor};
        }
    }
`


const CreateThirdRoadRouteModal = () => {

    const dispatch = useDispatch()
    const {selectedInspectionStationRoute} = useSelector((state) => state.admin3)

    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    
    const [route, setRoute] = useState(
        {
            latitude: "",
            longitude: "",
            radius: "",
            distanceToStation: "",
            message: "",
            type: 3
        })

       //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    
    const handleSubmit = () => {
        const addData = {
            roadRouteId: selectedInspectionStationRoute.id,
            latitude: parseFloat(route.latitude),
            longitude: parseFloat(route.longitude),
            radius: parseFloat(route.radius),
            distanceToStation: parseFloat(route.distanceToStation),
            message: route.message,
            type: 3
        };
    
        dispatch(createInspectionThirdRoadRoute(addData));
    };
    

    const handleChange = (e) => {
        setRoute({...route, [e.target.name]: e.target.value})
    };

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Rota Ekle"}/>
            <div className="content">
               <div className="input-containers">
                    <InputText data={route.latitude}  setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Lat" name={"latitude"} />
                    <InputText data={route.longitude}  setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Lng" name={"longitude"} />
                    <InputText data={route.radius} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Çap" name={"radius"} />
                    <InputText data={route.distanceToStation} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="İstasyona Mesafe" name={"distanceToStation"} />
                    <InputText data={route.message} setData={(e) => handleChange(e)} inputWidth={"100%"} labelText="Mesaj" name={"message"} />
               </div>
               <div className='button-grp'>
                    <Btn color={"#E85446"} bgColor={"transparent"} width="100px" radius={"10px"} handleClick={handleSubmit}>Ekle</Btn>
                    <Btn color={"#E85446"} bgColor={"transparent"} width="100px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Kapat</Btn>
                </div>
            </div>
            
        </div>
    </ModalContainer>
  )
}

export default CreateThirdRoadRouteModal